import { usePresenter } from './DomainMigrateHandler.presenter';

export const DomainMigrateHandler = (): null => {
  usePresenter();

  return null;
};
